/**
 * Ce qu'une page a à dire : ses gestes (sujets du Guide), ses fiches et ses
 * termes du Lexique. Une seule fonction, lue par le point de l'ampoule, le
 * bouton du Guide, les repères et le volet ; les trois sources restent
 * distinctes, chacune porte simplement ses `pages`.
 */
import { topicsForPage } from './onboarding';
import SAVOIRS from './savoirs';
import LEXICON from './lexicon';

export function fichesForPage(pageKey) {
  if (!pageKey) return [];
  return SAVOIRS.filter((f) => (f.pages || []).includes(pageKey));
}

export function termsForPage(pageKey) {
  if (!pageKey) return [];
  return LEXICON.filter((e) => (e.pages || []).includes(pageKey));
}

export function helpForPage(pageKey) {
  return {
    topics: topicsForPage(pageKey),
    fiches: fichesForPage(pageKey),
    terms: termsForPage(pageKey),
  };
}

/** true si la page a au moins un geste ou une fiche (le point de l'ampoule). */
export function pageHasHelp(pageKey) {
  return topicsForPage(pageKey).length > 0 || fichesForPage(pageKey).length > 0;
}
